import { v2UiEnabled } from '@/components/DmpV2/features';
import type { AiMediaLaunch } from '@/api/aiMedia.api';

export function validateAiMediaLaunch(data: AiMediaLaunch, allowedOrigin: string): string {
  const origin = new URL(allowedOrigin);
  const url = new URL(data.launchUrl);
  if (origin.protocol !== 'https:' || origin.origin !== allowedOrigin
    || url.origin !== origin.origin || url.username || url.password || url.hash
    || url.pathname !== '/auth/origin' || url.searchParams.get('origin') !== 'dmp'
    || !url.searchParams.get('ticket') || url.searchParams.getAll('ticket').length !== 1
    || url.searchParams.getAll('origin').length !== 1
    || !Number.isFinite(Date.parse(data.expiresAt)) || Date.parse(data.expiresAt) <= Date.now()) {
    throw new Error('invalid_launch');
  }
  return url.href;
}

export type AiMediaErrorKey = 'quota_exhausted' | 'free_quota_contract_pending' | 'profile_incomplete' | 'sign_in' | 'forbidden' | 'rate_limited' | 'unavailable';

export function aiMediaErrorKey(error: unknown): AiMediaErrorKey {
  const response = (error as { response?: { status?: number; data?: { data?: { code?: string } } } })?.response;
  const code = response?.data?.data?.code;
  if (code === 'quota_exhausted') return 'quota_exhausted';
  if (code === 'free_quota_contract_pending') return 'free_quota_contract_pending';
  if (code === 'profile_incomplete') return 'profile_incomplete';
  if (response?.status === 401) return 'sign_in';
  if (response?.status === 403) return 'forbidden';
  if (response?.status === 429) return 'rate_limited';
  return 'unavailable';
}

/** UI 尚未啟用時，首頁與側欄都保留原正式導覽。 */
export function resolveAiMediaNavigationLinks<T extends { url?: string; children?: unknown }>(links: T[]): T[] {
 if (v2UiEnabled()) return links;
 return links.filter(link => link.url !== '/aiMedia').map(link => Array.isArray(link.children)
   ? { ...link, children: resolveAiMediaNavigationLinks(link.children) } : link);
}
